module.exports = __webpack_public_path__ + "static/media/blog-49.67d5e59a.webp";